import Param from "../../../param";
import Util from "../../libs/util";


const param = new Param();
const util = new Util();

/* --------------------------------------------
*
*  -- [ aboutの背景 ]
*
* -------------------------------------------- */

export default class AboutBg {
    constructor(w,h){

        this.w = w;
        this.h = h;

        this.mesh = [];
        this.uniforms = [];

        this.bgMesh;
        this.bgUniforms;

        this.conf = {
        }

        this.save = { /* 一時的に保持するもの */
        }



    }
    init(scene){

        let _bgGeo = new THREE.PlaneGeometry(2000, 1000, 32, 32);
        _bgGeo.verticesNeedUpdate=true;

        this.bgUniforms = {
            // opacity   :{value:1.0},
            time : {type: "f", value: 1},
            resolution : { type: "v2", value: new THREE.Vector2() },
            mouse : { type: "v2", value: new THREE.Vector2() },
            // start : {type: "f", value: 1.0},
            // noiseMulti : {type: "f", value: 0.5},
        }

        // let _bgMat =  new THREE.MeshBasicMaterial({
        //     color:0xffffff,
        // });


        let _bgMat = new THREE.ShaderMaterial({
            // vertexShader: require('../../../../shader/mainvisual.vert'),
            vertexShader: require('../../../../shader/aboutBg.vert'),
            fragmentShader: !Useragnt.mobile? require('../../../../shader/aboutBg.frag'):require('../../../../shader/sp/aboutBg.frag'),
            transparent   :true,
            // side:THREE.DoubleSide,
            // blending:THREE.MultiplyBlending,
            blending:THREE.AdditiveBlending,
            // blending:THREE.AdditiveAlphaBlending,
            // blending:THREE.NoBlending,
            uniforms:this.bgUniforms
        });

        this.bgUniforms.resolution.value.x = this.w;
        this.bgUniforms.resolution.value.y = this.h;

        this.bgMesh = new THREE.Mesh( _bgGeo,_bgMat );

        this.bgMesh.scale.set(2,2,1)
        this.bgMesh.position.y = this.h<700? 1400 : this.h*2;
        // this.bgMesh.position.x = -this.w/2;
        this.bgMesh.position.z = 1;
        // this.bgMesh.opacity = 0.0;

        scene.add(this.bgMesh);

    }
    show(){
        TweenMax.to(this.bgMesh.position,0.6,{
            y: 0,
            ease: Power2.easeOut,
        });
    }
    out(){
        TweenMax.to(this.bgMesh.position,0.4,{
            y: this.h<700? 1400 : this.h*2,
            ease: Power2.easeIn,
        });
    }
    render(mouse,time,fpsRate){

        if(this.bgUniforms) {
            this.bgUniforms.time.value += 0.001;
            this.bgUniforms.mouse.value.x = -mouse.x/10000;
            this.bgUniforms.mouse.value.y = -mouse.y/10000;
        }

    }
    resize(w,h,current){
        this.w = w;
        this.h = h;
        if(this.bgMesh&&current!=4) this.bgMesh.position.y = this.h<700? 1400 : this.h*2;
        if(this.bgUniforms&&current==4){
            this.bgUniforms.resolution.value.x = this.w;
            this.bgUniforms.resolution.value.y = this.h;
        }
    }

}